import { AbstractMutableMapyktux9ubhc1g as AbstractMutableMap } from './AbstractMutableMap.mjs';
import { InternalHashMapmpvpylj0ut6l as InternalHashMap } from './InternalHashMap.mjs';
import {
  HashMapKeys28ggmxpft3hz9 as HashMapKeys,
  HashMapValues3umcxpfyfunqf as HashMapValues,
  HashMapEntrySet29p2ksc4wcy5i as HashMapEntrySet,
} from './HashMapEntry.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { KtMutableMap1kqeifoi36kpz as KtMutableMap } from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlin_collections_HashMap(_this__u8e3s4) {
  _this__u8e3s4.q8_1 = null;
}
var HashMapClass;
function HashMap() {
  if (HashMapClass === VOID) {
    class $ extends AbstractMutableMap() {
      static r8(internalMap) {
        var $this = this.r7();
        init_kotlin_collections_HashMap($this);
        $this.p8_1 = internalMap;
        return $this;
      }
      static s8() {
        return this.r8(InternalHashMap().d9());
      }
      static e9(initialCapacity, loadFactor) {
        return this.r8(InternalHashMap().f9(initialCapacity, loadFactor));
      }
      static g9(initialCapacity) {
        return this.e9(initialCapacity, 1.0);
      }
      static h9(original) {
        return this.r8(InternalHashMap().i9(original));
      }
      y4() {
        this.p8_1.y4();
      }
      t4(key) {
        return this.p8_1.j9(key);
      }
      u4(value) {
        return this.p8_1.u4(value);
      }
      v7() {
        return HashMapKeys().l9(this.p8_1);
      }
      y7() {
        return HashMapValues().n9(this.p8_1);
      }
      l3() {
        var tmp0_elvis_lhs = this.q8_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = HashMapEntrySet().p9(this.p8_1);
          this.q8_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      v4(key) {
        return this.p8_1.v4(key);
      }
      b5(key, value) {
        return this.p8_1.b5(key, value);
      }
      c5(key) {
        return this.p8_1.c5(key);
      }
      q2() {
        return this.p8_1.q2();
      }
      d5(from) {
        return this.p8_1.d5(from);
      }
    }
    initMetadataForClass($, 'HashMap', $.s8, VOID, [KtMutableMap()]);
    HashMapClass = $;
  }
  return HashMapClass;
}
//region block: exports
export {
  HashMap as HashMap1a0ld5kgwhmhv,
};
//endregion

//# sourceMappingURL=HashMap.mjs.map
